<template>
  <div class="column is-12">
    <div class="card">
      <header class="header-card">
        <p>
          {{$t('societes.masqueBloc.titleCompta')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <b-field :label="$t('societes.masqueBloc.masqueCompteComptableClient')"
                   class="column is-4">
            <b-input v-model="societe.masqueCompteComptableClient"
                     @focus="openPopUpCompteComptable('masqueCompteComptableClient')">
            </b-input>
          </b-field>
          <b-field :label="$t('societes.masqueBloc.masqueCompteComptableBailleur')"
                   class="column is-4">
            <b-input v-model="societe.masqueCompteComptableBailleur"
                     @focus="openPopUpCompteComptable('masqueCompteComptableBailleur')">
            </b-input>
          </b-field>
        </div>
      </div>
    </div>
    <b-modal v-model="openPopUpCompteComptableGenerator"
             has-modal-card class="modal">
      <pop-up-code-generator-compte-comptable :value="societe[keyToUpdate]"
                                              :typeLibelle="keyToUpdate"
                                              @updateCompteComptable="
                                              societe[keyToUpdate] = $event">
      </pop-up-code-generator-compte-comptable>
    </b-modal>
  </div>
</template>

<script>

import popUpCodeGeneratorCompteComptable
  from '@/components/parametrage/societes/ajoutEditionSociete/masque/masqueGenerator/p_codeGeneratorCompteComptable';

export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openPopUpCompteComptableGenerator: false,
      keyToUpdate: null,
    };
  },
  components: {
    popUpCodeGeneratorCompteComptable,
  },
  methods: {
    openPopUpCompteComptable(key) {
      this.keyToUpdate = key;
      this.openPopUpCompteComptableGenerator = true;
    },
  },
};
</script>
